import { render, staticRenderFns } from "./OrganizationUnits.vue?vue&type=template&id=5ae2cc9b&scoped=true"
import script from "./OrganizationUnits.vue?vue&type=script&lang=js"
export * from "./OrganizationUnits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae2cc9b",
  null
  
)

export default component.exports